import { Description, Form, FormButton, Title, Wrapper } from '../style';
import Tabs from '../../../components/Tabs';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import Input from '../../../components/Input';

const tabs = [
  { title: 'Sign In', value: 'login' },
  { title: 'Register', value: 'signup' }
];

const Signup = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const tabValue = useMemo(() => location.pathname.replace('/', ''), [location]);

  const onTabChange = tab => navigate('/' + tab.value);

  const onSubmit = () => navigate('/password');

  return (
    <Wrapper>
      <Title>Welcome to DATOX</Title>
      <Description>
        Datox seamlessly integrates data from various sources, including databases, APIs, and
        external applications
      </Description>
      <Tabs tabs={tabs} value={tabValue} onClick={onTabChange} />
      <Form>
        <Input label="Name of Company" placeholder="Type your company name" />
        <Input label="Email" placeholder="Type your email" />
        <Input label="Phone Number" placeholder="Type your phone number" />

        <FormButton maxWidth={true} onClick={onSubmit}>
          Continue with Email
        </FormButton>
      </Form>
    </Wrapper>
  );
};

export default Signup;
